export const statesDropdown = [
    { label: "Alabama", value: "Alabama" },
    { label: "Alaska", value: "Alaska" },
    { label: "Arizona", value: "Arizona" },
    { label: "Arkansas", value: "Arkansas" },
    { label: "California", value: "California" },
    { label: "Colorado", value: "Colorado" },
    { label: "Connecticut", value: "Connecticut" },
    { label: "Delaware", value: "Delaware" },
    { label: "District of Columbia", value: "District of Columbia" },
    { label: "Florida", value: "Florida" },
    { label: "Georgia", value: "Georgia" },
    { label: "Hawaii", value: "Hawaii" },
    { label: "Idaho", value: "Idaho" },
    { label: "Illinois", value: "Illinois" },
    { label: "Indiana", value: "Indiana" },
    { label: "Iowa", value: "Iowa" },
    { label: "Kansas", value: "Kansas" },
    { label: "Kentucky", value: "Kentucky" },
    { label: "Louisiana", value: "Louisiana" },
    { label: "Maine", value: "Maine" },
    { label: "Maryland", value: "Maryland" },
    { label: "Massachusetts", value: "Massachusetts" },
    { label: "Michigan", value: "Michigan" },
    { label: "Minnesota", value: "Minnesota" },
    { label: "Mississippi", value: "Mississippi" },
    { label: "Missouri", value: "Missouri" },
    { label: "Montana", value: "Montana" },
    { label: "Nebraska", value: "Nebraska" },
    { label: "Nevada", value: "Nevada" },
    { label: "New Hampshire", value: "New Hampshire" },
    { label: "New Jersey", value: "New Jersey" },
    { label: "New Mexico", value: "New Mexico" },
    { label: "New York", value: "New York" },
    { label: "North Carolina", value: "North Carolina" },
    { label: "North Dakota", value: "North Dakota" },
    { label: "Ohio", value: "Ohio" },
    { label: "Oklahoma", value: "Oklahoma" },
    { label: "Oregon", value: "Oregon" },
    { label: "Pennsylvania", value: "Pennsylvania" },
    { label: "Rhode Island", value: "Rhode Island" },
    { label: "South Carolina", value: "South Carolina" },
    { label: "South Dakota", value: "South Dakota" },
    { label: "Tennessee", value: "Tennessee" },
    { label: "Texas", value: "Texas" },
    { label: "Utah", value: "Utah" },
    { label: "Vermont", value: "Vermont" },
    { label: "Virginia", value: "Virginia" },
    { label: "Washington", value: "Washington" },
    { label: "West Virginia", value: "West Virginia" },
    { label: "Wisconsin", value: "Wisconsin" },
    { label: "Wyoming", value: "Wyoming" },
];

/*export const states = [
    { label: "Alabama (AL)", value: "Alabama" },
    { label: "Alaska (AK)", value: "Alaska" },
    { label: "Arizona (AZ)", value: "Arizona" },
    { label: "Arkansas (AR)", value: "Arkansas" },
    { label: "California (CA)", value: "California" },
    { label: "Colorado (CO)", value: "Colorado" },
    { label: "Connecticut (CT)", value: "Connecticut" },
    { label: "Delaware (DE)", value: "Delaware" },
    { label: "Florida (FL)", value: "Florida" },
    { label: "Georgia (GA)", value: "Georgia" },
    { label: "Hawaii (HI)", value: "Hawaii" },
    { label: "Idaho (ID)", value: "Idaho" },
    { label: "Illinois (IL)", value: "Illinois" },
    { label: "Indiana (IN)", value: "Indiana" },
    { label: "Iowa (IA)", value: "Iowa" },
    { label: "Kansas (KS)", value: "Kansas" },
    { label: "Kentucky (KY)", value: "Kentucky" },
    { label: "Louisiana (LA)", value: "Louisiana" },
    { label: "Maine (ME)", value: "Maine" },
    { label: "Maryland (MD)", value: "Maryland" },
    { label: "Massachusetts (MA)", value: "Massachusetts" },
    { label: "Michigan (MI)", value: "Michigan" },
    { label: "Minnesota (MN)", value: "Minnesota" },
    { label: "Mississippi (MS)", value: "Mississippi" },
    { label: "Missouri (MO)", value: "Missouri" },
    { label: "Montana (MT)", value: "Montana" },
    { label: "Nebraska (NE)", value: "Nebraska" },
    { label: "Nevada (NV)", value: "Nevada" },
    { label: "New Hampshire (NH)", value: "New Hampshire" },
    { label: "New Jersey (NJ)", value: "New Jersey" },
    { label: "New Mexico (NM)", value: "New Mexico" },
    { label: "New York (NY)", value: "New York" },
    { label: "North Carolina (NC)", value: "North Carolina" },
    { label: "North Dakota (ND)", value: "North Dakota" },
    { label: "Ohio (OH)", value: "Ohio" },
    { label: "Oklahoma (OK)", value: "Oklahoma" },
    { label: "Oregon (OR)", value: "Oregon" },
    { label: "Pennsylvania (PA)", value: "Pennsylvania" },
    { label: "Rhode Island (RI)", value: "Rhode Island" },
    { label: "South Carolina (SC)", value: "South Carolina" },
    { label: "South Dakota (SD)", value: "South Dakota" },
    { label: "Tennessee (TN)", value: "Tennessee" },
    { label: "Texas (TX)", value: "Texas" },
    { label: "Utah (UT)", value: "Utah" },
    { label: "Vermont (VT)", value: "Vermont" },
    { label: "Virginia (VA)", value: "Virginia" },
    { label: "Washington (WA)", value: "Washington" },
    { label: "West Virginia (WV)", value: "West Virginia" },
    { label: "Wisconsin (WI)", value: "Wisconsin" },
    { label: "Wyoming (WY)", value: "Wyoming" },
];*/
